// extracted by mini-css-extract-plugin
export default {"project__card":"Project_project__card__pHwtK","github__link":"Project_github__link__-Yc4Z"};